// src/components/EmailTemplates/TemplateItem.js
import React, { useRef, useEffect } from 'react';

const TemplateItem = ({ template, onClick }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    if (iframeRef.current && template.html) {
      const doc = iframeRef.current.contentDocument || iframeRef.current.contentWindow.document;
      doc.open();
      doc.write(template.html);
      doc.close();
    }
  }, [template.html]);

  return (
    <div className="emailtemplates-item" onClick={onClick}>
      <div
        className="emailtemplates-preview-wrapper"
        onMouseEnter={(e) => {
          e.currentTarget.querySelector('.emailtemplates-hover').style.opacity = '1';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.querySelector('.emailtemplates-hover').style.opacity = '0';
        }}
      >
        <iframe
          ref={iframeRef}
          className="emailtemplates-preview"
          title={template.title}
          scrolling="no" // Disable iframe scrollbar
        ></iframe>
        <div className="emailtemplates-hover">
          <h3>{template.title}</h3>
          <p>{template.description}</p>
        </div>
      </div>
    </div>
  );
};

export default TemplateItem;